import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { TableRow } from '@material-ui/core';
import Swal from 'sweetalert2';
import * as Utils from '../../commons/utils/Utils';
import { StyledTableCellProps as StyledTableCell } from '../../commons/utils/TableStyles';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';

const getTipoItemChips = (tipoItemId, intl) => {
  const chips = [];
  if (tipoItemId === 1 || tipoItemId === 0) {
    chips.push(intl.formatMessage({ id: 'itemClasificacionesGrid.tipoItem.producto', defaultMessage: 'Producto' }));
  }
  if (tipoItemId === 2 || tipoItemId === 0) {
    chips.push(intl.formatMessage({ id: 'itemClasificacionesAbm.tipoItem.manoDeObra', defaultMessage: 'Mano de Obra' }));
  }
  return chips;
};

const ItemClasificacionesGridRow = (props) => {
  const intl = props.intl;
  const row = props.row;
  const baseUrl = props.baseUrl;
  const [redirectTo, setRedirectTo] = useState(null);

  const handleDelete = () => {
    Swal.fire({
      title: intl.formatMessage({ id: 'confirm_deletion', defaultMessage: '¿Confirma la eliminación?' }),
      html:
        intl.formatMessage({ id: 'itemClasificacionesAbm.eliminar.se_eliminara_la_clasificacion', defaultMessage: 'Se eliminará la Clasificación' }) +
        ': ' +
        '<b>' +
        row.nombre +
        '</b>',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: intl.formatMessage({ id: 'yes', defaultMessage: 'Si' }),
      cancelButtonText: intl.formatMessage({ id: 'no', defaultMessage: 'No' }),
    }).then((result) => {
      if (result.value) {
        Utils.deleteData('/item/clasificaciones/' + row.id)
          .then(() => {
            props.fetchRows();
            Swal(intl.formatMessage({ id: 'Eliminado!', defaultMessage: 'Eliminado!' }), '', 'success');
          })
          .catch((err) => {
            Swal(err.getMessage ? err.getMessage() : 'Error', '', 'error');
          });
      }
    });
  };

  return (
    <>
      {redirectTo && <Redirect push to={redirectTo} />}
      <TableRow>
        <StyledTableCell align="left">{row.id}</StyledTableCell>
        <StyledTableCell align="left">{row.nombre}</StyledTableCell>
        {ConfigBusiness.get('tickets.trabajaConManoDeObra.habilitado') === 'true' && (
          <StyledTableCell align="left">
            {getTipoItemChips(row.tipoItemId, intl).map((label) => (
              <span
                key={label}
                style={{
                  display: 'inline-block',
                  backgroundColor: '#6b6f82a8',
                  color: '#fff',
                  borderRadius: 4,
                  padding: '2px 8px',
                  fontSize: 12,
                  fontWeight: 500,
                  whiteSpace: 'nowrap',
                  marginRight: '4px',
                }}
              >
                {label}
              </span>
            ))}
          </StyledTableCell>
        )}
        <StyledTableCell>
          <div className="d-inline-flex">
            {props.permissions.visualizar && (
              <button
                className="action view btn btn-sm btn-icon btn-dt-grid text-success"
                title="Ver"
                data-toggle="tooltip"
                data-placement="top"
                onClick={() => setRedirectTo(baseUrl + '/' + row.id)}
              >
                <i className="fa fa-search fa-xs" />
              </button>
            )}
            {props.permissions.modificar && (
              <button
                className="action edit btn btn-sm btn-icon btn-dt-grid text-success"
                title="Editar"
                data-toggle="tooltip"
                data-placement="top"
                onClick={() => setRedirectTo(baseUrl + '/' + row.id + '/edit')}
              >
                <i className="fa fa-pencil fa-xs" />
              </button>
            )}
            {props.permissions.eliminar && row.activa ? (
              <button
                className="action delete btn btn-sm btn-icon btn-dt-grid text-danger"
                title="Eliminar"
                data-toggle="tooltip"
                data-placement="top"
                onClick={() => handleDelete()}
              >
                <i className="fa fa-trash fa-xs" />
              </button>
            ) : (
              ''
            )}
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
};

//exporta el componente con las acciones Ver/Editar/Eliminar (con permisos)
export default ItemClasificacionesGridRow;
